/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../config';
import API from '../../../network';

const useInterviewPositions = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    data, error, refetch, isFetching,
  } = useQuery({
    queryKey: QueryKeys.INTERVIEWPOSITIONS,
    queryFn: async () => API.getInstance()
      .getInterviewPositions().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const interviewPositionsOptions = React.useMemo(
    () => data?.map((option) => ({
      label: `${option.interviewID} - ${option.positionTitle}`,
      value: option.interviewPositionId,
    })) || [],
    [data],
  );

  return {
    interviewPositionsLoading: isFetching,
    interviewPositionsOptions,
    data,
    error,
    fetchInterviewPositions: refetch,
  };
};

export {
  useInterviewPositions,
};
